<template>
  <div :class="$options.name">
    <v-card>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.name"
            :value="data.name"
            :rules="rules.name"
            label="Название формы"
          />
          <div class="mb-2">
            <span>Поля формы</span>
          </div>
          <div v-if="!form.fields.length" class="caption">Нет полей</div>
          <FormField
            v-for="(field, index) in form.fields"
            :key="`field-${field.id}`"
            :field-types="fieldTypes"
            :field="field"
            :index="index"
            :length="form.fields.length"
            :rules="rules"
            @remove="removeField(index)"
            @swap="swapFields"
            @title-change="onTitleFieldChange"
            @update="handleUpdate($event, index)"
            @pushValue="addPreparedValue"
            @removeValue="removePreparedValue($event, index)"
            @updatePepared="updatePeparedValues($event, index)"
          />
          <div class="d-flex justify-end mt-1">
            <v-btn
              v-permission="['object-form-edit']"
              class="primary"
              @click="addField"
            >
              Добавить поле
            </v-btn>
            <v-btn class="green ml-4" dark @click="onSubmit">
              {{ isEdit ? 'Сохранить изменения' : 'Добавить форму' }}
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormField from './FormField.vue';

const createDefaultForm = () => ({
  name: '',
  fields: [],
});

export default {
  name: 'object-form-create-form',
  components: {
    FormField,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    isEdit: Boolean,
    value: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    form: createDefaultForm(),
    valid: true,
    rules: {
      name: [
        v => !!v || 'Название формы обязательно для заполнения',
      ],
      fieldName: [
        v => !!v || 'Название поля обязательно для заполнения',
      ],
      itemName: [
        v => !!v || 'Название элемента обязательно для заполнения',
      ],
    },
  }),
  computed: {
    ...mapState('objectForms', ['fieldTypes']),
  },
  async created() {
    if (!this.fieldTypes.length) {
      await this.getFieldTypes();
    }

    this.updateData();
    this.valuesWithoutChange = Object.assign({}, this.form);
    this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
  },
  methods: {
    ...mapActions('objectForms', ['getFieldTypes']),

    beforeLeave() {
      return this.form;
    },

    addField() {
      this.form.fields.push({
        create: true,
        type: 'text',
        name: '',
        preparedValues: [],
        filterable: false,
        public: false,
        isTitle: false,
        voronoiAvailable: false,
      });
    },
    addPreparedValue(i) {
      this.form.fields[i].preparedValues.push('');
    },
    removeField(i) {
      if (this.form.fields[i].id) {
        this.$set(this.form.fields[i], 'delete', true);
      } else {
        this.$delete(this.form.fields, i);
      }
    },
    removePreparedValue(i, index) {
      this.form.fields[index].preparedValues.splice(i, 1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.valuesWithoutChange = Object.assign({}, this.form);
        this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
        this.$emit('submit', this.form);
      }
    },

    handleUpdate([value, prop], index) {
      this.form.fields[index][prop] = value;
    },

    updatePeparedValues([value, prop, i], index) {
      this.form.fields[index][prop][i] = value;
    },

    updateData() {
      this.form = JSON.parse(JSON.stringify({
        ...this.form,
        ...this.data,
      }));
      this.form.fields = this.form.fields.map(_ => ({
        ..._,
        isTitle: this.data.titleField ? this.data.titleField.id === _.id : false,
      }));
    },

    onTitleFieldChange([e, index]) {
      this.form.fields = this.form.fields.map(_ => ({
        ..._,
        isTitle: false,
      }));
      this.form.fields[index].isTitle = e;
    },

    swapFields([i, j]) {
      const temp = this.form.fields[j];
      this.$set(this.form.fields, j, this.form.fields[i]);
      this.$set(this.form.fields, i, temp);
    },
  },
};
</script>

<style scoped>

</style>
